import { currencySymbolMap, LangEum } from "@/constant"
import { formatMoney } from "@/utils";
import { ICouponType } from "../typing"

export const rule: any = {
    zh: '规则',
    'zh-TW': '規則',
    [LangEum['zh-MO']]: '規則',
    [LangEum['zh-TW2']]: '規則',
    en: 'Rules',
    ja: 'ルール',
    ko: '행사규칙',
    [LangEum['zh-SG']]: '规则',
    [LangEum['zh-MY']]: '规则',
};

export const successMsgMap: any = {
    zh: '领取成功',
    'zh-TW': '領取成功',
    [LangEum['zh-MO']]: '領取成功',
    [LangEum['zh-TW2']]: '領取成功',
    en: 'Claimed successfully',
    ja: '受取完了',
    [LangEum['zh-SG']]: '领取成功',
    [LangEum['zh-MY']]: '领取成功',
};
  
export const errorMsgMap: any = {
    'zh-TW': '该优惠券已领完',
    [LangEum['zh-MO']]: '該優惠券已領完',
    [LangEum['zh-TW2']]: '該優惠券已領完',
    en: 'We’re out of this coupon',
    ja: 'このクーポンは受取上限に達した',
    [LangEum['zh-SG']]: '该优惠券已领完',
    [LangEum['zh-MY']]: '该优惠券已领完',
};

export const limitTextMap: any = {
    zh: '无门槛',
    'zh-TW': '無門檻',
    [LangEum['zh-MO']]: '無門檻',
    [LangEum['zh-TW2']]: '無門檻',
    en: 'With Any Order',
    ja: '任意可用',
    [LangEum['zh-SG']]: '无门槛',
    [LangEum['zh-MY']]: '无门槛',
};

export const freeShipTextMap: any = {
    zh: '包邮券',
    'zh-TW': '包郵券',
    [LangEum['zh-MO']]: '包郵券',
    [LangEum['zh-TW2']]: '包郵券',
    en: 'Free Shipping',
    ja: '送料無料',
    [LangEum['zh-SG']]: '包邮券',
    [LangEum['zh-MY']]: '包邮券',
};

export const rankTitleMap: any = {
    zh: 'POIZON',
    'zh-TW': 'POIZON',
    [LangEum['zh-MO']]: 'POIZON',
    [LangEum['zh-TW2']]: 'POIZON',
    en: 'POIZON',
    ja: 'POIZON',
    [LangEum['zh-SG']]: 'POIZON',
    [LangEum['zh-MY']]: 'POIZON',
}

export const oldUserMsg1 = {
    zh: '很抱歉，您是POIZON的老朋友了',
    'zh-TW': '很抱歉，您是POIZON的老朋友了',
    [LangEum['zh-MO']]: '很抱歉，您是POIZON的老朋友了',
    [LangEum['zh-TW2']]: '很抱歉，您是POIZON的老朋友了',
    en: 'Sorry, these are New User Offers.',
    ja: '大変申し訳ございません',
    [LangEum['zh-SG']]: '很抱歉，您是POIZON的老朋友了',
    [LangEum['zh-MY']]: '很抱歉，您是POIZON的老朋友了',
};

export const oldUserMsg2 = {
    zh: '优惠券是新用户专享福利',
    'zh-TW': '优惠券是新用戶專享福利',
    [LangEum['zh-MO']]: '优惠券是新用戶專享福利',
    [LangEum['zh-TW2']]: '优惠券是新用戶專享福利',
    en: `Only new users qualify for welcome coupons.`,
    ja: ' この特典は新ユーザー限定です。',
    [LangEum['zh-SG']]: '优惠券是新用户专享福利',
    [LangEum['zh-MY']]: '优惠券是新用户专享福利',
};

export const oldUserMsg3 = {
    zh: '您已领取过新人礼券啦，去逛逛吧～',
    'zh-TW': '您已領取過新人禮券啦，去逛逛吧～',
    [LangEum['zh-MO']]: '您已領取過新人禮券啦，去逛逛吧～',
    [LangEum['zh-TW2']]: '您已領取過新人禮券啦，去逛逛吧～',
    en: `You've already claimed the welcome coupons. `,
    ja: '新ユーザー特典は受取済みです!早速商品みてみよう！',
    [LangEum['zh-SG']]: '您已领取过新人礼券啦，去逛逛吧～',
    [LangEum['zh-MY']]: '您已领取过新人礼券啦，去逛逛吧～',
};

export const countTimeTxt1 = {
    zh: '距过期',
    'zh-TW': '距過期',
    [LangEum['zh-MO']]: '距過期',
    [LangEum['zh-TW2']]: '距過期',
    en: 'Expires in',
    ja: '終了まで',
    [LangEum['zh-SG']]: '距过期',
    [LangEum['zh-MY']]: '距过期',
};

export const countTimeTxt2 = {
    zh: '天',
    'zh-TW': '天',
    [LangEum['zh-MO']]: '天',
    [LangEum['zh-TW2']]: '天',
    en: 'Day',
    ja: '日',
    [LangEum['zh-SG']]: '天',
    [LangEum['zh-MY']]: '天',
};

export const countTimeTxt3: any = {
    zh: '已过期',
    'zh-TW': '已過期',
    [LangEum['zh-MO']]: '已過期',
    [LangEum['zh-TW2']]: '已過期',
    [LangEum['zh-SG']]: '已过期',
    [LangEum['zh-MY']]: '已过期',
    en: 'Expired',
    ja: '期限切れ',
};

export const getLimit = (lang: string, region: string, limitAmount: number, couponType: ICouponType, deductionAmount = 0): string => {
    const calLimitAmount = currencySymbolMap[region] + formatMoney(limitAmount)
    const calDeductionAmount = currencySymbolMap[region] + formatMoney(deductionAmount)
    const direct = {
        zh: `滿${calLimitAmount}可用`,
        'zh-TW': `滿${calLimitAmount}可用`,
        [LangEum['zh-MO']]: `滿${calLimitAmount}可用`,
        [LangEum['zh-TW2']]: `滿${calLimitAmount}可用`,
        en: `Order≥ ${calLimitAmount}`,
        ja: `${calLimitAmount}以上で使用可能`,
        [LangEum['zh-SG']]: `滿${calLimitAmount}可用`,
        [LangEum['zh-MY']]: `滿${calLimitAmount}可用`,
    };

    const directType2 = {
        zh: `滿${calLimitAmount}减${calDeductionAmount}券`,
        'zh-TW': `滿${calLimitAmount}减${calDeductionAmount}券`,
        [LangEum['zh-MO']]: `滿${calLimitAmount}减${calDeductionAmount}券`,
        [LangEum['zh-TW2']]: `滿${calLimitAmount}减${calDeductionAmount}券`,
        [LangEum['zh-SG']]: `滿${calLimitAmount}减${calDeductionAmount}券`,
        [LangEum['zh-MY']]: `滿${calLimitAmount}减${calDeductionAmount}券`,
        // 注意，这个末尾有个空格，不要问为什么，不想再用lang控制样式
        en: `${calLimitAmount} Off ${calDeductionAmount} `,
        ja: `${calLimitAmount}以上で${calDeductionAmount}値引き`,
    }

    const shippingText = limitTextMap;

    console.log(calLimitAmount, calDeductionAmount)

    switch(couponType) {
        case ICouponType.direct:
            if (limitAmount === 0) return shippingText[lang]
            if (deductionAmount !== 0) return directType2[lang]
            return direct[lang];
        case ICouponType.shipping:
            if (limitAmount === 0) return shippingText[lang];
            return direct[lang]
        default:
            return ''
    }
};